module.exports = __webpack_public_path__ + "media/images/consultancy-cost-white-5271274d52dea4b8718adbf7eb175dc4.svg";